export const SEARCH_V2_PATH = '/search/v2'

export const SEARCH_V2_ROUTE_NAME = 'searchV2'

export const FEATURE_OPEN_SEARCH = 'open_search'
